module.exports = __webpack_public_path__ + "img/13.9e7d5982.jpg";